import { React } from "react";
const Siniestralidad = ({ nombre, mdstatus, eseditable }) => {
    return(
        <div className=" w-full h-full">
        <iframe title="Siniestralidad"  className=" w-full h-full border-0"
       src="https://docs.google.com/spreadsheets/d/1Gh34RGz4_Kwo8rDuGCLqeM18MnMlPEEvhf4bNXyAvX4/edit?gid=701119699#gid=701119699"
        allowfullscreen sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox single=true;widget=true;headers=false"></iframe></div>
    )
}
export default Siniestralidad;